import { useSeoRobots } from '@/hooks/useSeoRobots';

/** Gestion SEO globale par route (robots noindex sur l’app privée). */
export function SeoRouteHead() {
  useSeoRobots();
  return null;
}
